import { gql } from "@apollo/client";

export const MARKER_CONTENT = gql`
  query MarkerContent($culture: String!, $path_in: [String]!) {
    page(where: {localization: {culture: $culture}, path_in: $path_in}) {
      __typename
      contentItemId
      content {
        contentItems {
          __typename
          ... on MapWidget {
            contentType
            markerGroups {
              contentItems {
                __typename
                ... on MapMarkerGroup {
                  contentItemId
                  markers {
                    contentItems {
                      __typename
                      ... on MapMarker {
                        contentItemId
                        content {
                          contentItems {
                            __typename
                            ... on ParagraphWidget {
                              contentType
                              text {
                                html
                              }
                            }
                            __typename
                            ... on VideoWidget {
                              contentType
                              displayText
                              widgetArea {
                                heightMode
                                customHight
                                widthMode
                              }
                              cover {
                                paths
                              }
                              sources {
                                paths
                              }
                              description {
                                html
                              }
                            }
                            __typename
                            ... on FileWidget {
                              contentType
                              files {
                                paths
                                texts
                              }
                            }
                            __typename
                            ... on ImageGalleryWidget {
                              contentType
                              widgetArea {
                                heightMode
                                customHight
                                widthMode
                              }
                              images {
                                paths
                              }
                            }
                            __typename
                            ... on ItineraryWidget {
                              contentType
                              activities {
                                contentItems {
                                  displayText
                                  __typename
                                  ... on ItineraryActivity {
                                    activity
                                    brief {
                                      html
                                    }
                                    endTime
                                    gallery {
                                      paths
                                    }
                                    startTime
                                    location {
                                      latitude
                                      longitude
                                    }
                                    day
                                  }
                                }
                              }
                            }
                            __typename
                            ... on SlideshowWidget {
                              contentType
                              widgetArea {
                                heightMode
                                customHight
                                widthMode
                              }
                              slides {
                                contentItems {
                                  contentItemId
                                  __typename
                                  ... on SlideshowItem {
                                    contentType
                                    media {
                                      paths
                                      texts
                                    }
                                    textOverly {
                                      html
                                    }
                                    buttonText
                                    navigateUrl
                                    animation
                                  }
                                }
                              }
                            }
                            __typename
                            ... on MapWidget {
                              contentType
                              provider
                              style
                              zoom
                              center {
                                latitude
                                longitude
                              }
                              defaultMarkerIcon {
                                paths
                              }
                            }
                            __typename
                            ... on CardWidget {
                              contentType
                              contentItemId
                              columnCount
                              items {
                                contentItems {
                                  __typename
                                  ... on CardItem {
                                    displayText
                                    image {
                                      paths
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }  
`